<template>
  <div>
    <v-data-table
      fixed-header
      dense
      height="470"
      :headers="headers"
      :items="history"
      :footer-props="{
        'items-per-page-options': [20, 30, 50, -1]
      }"
    >
      <template v-slot:[`item.Is_Pending`]="{ item }">
        <span v-if="item.Status === 'Pending'" class="orange--text text--darken-2">Pending</span>
        <span v-else-if="item.Status === 'Approved'" class="success--text darken-2">Approved</span>
        <span v-else class="error--text darken-2">Rejected</span>
      </template>
      <template v-slot:[`item.Approved`]="{ item }">
        <template v-if="item.Need_Additional_Approval">
          <span v-if="!item.Approved && !item.Rejection_Reason" class="orange--text text--darken-2">Pending</span>
          <span v-else-if="item.Approved" class="success--text darken-2">Approved by {{ item.Confirmer_Full_Name }}</span>
          <span v-else class="error--text darken-2">
            Rejected by {{ item.Confirmer_Full_Name }}
            <br v-if="item.Rejection_Reason"><b v-if="item.Rejection_Reason">Reason: {{ item.Rejection_Reason }}</b>
          </span>
        </template>
        <template v-else>
          <span v-if="item.Status === 'Pending'" class="orange--text text--darken-2">Pending</span>
          <span v-else-if="item.Status === 'Approved'" class="success--text darken-2">Approved by {{ item.Confirmer_Full_Name }}</span>
          <span v-else-if="item.Status === 'Rejected'" class="error--text darken-2">
            Rejected by {{ item.Confirmer_Full_Name }}
            <br v-if="item.Rejection_Reason"><b v-if="item.Rejection_Reason">Reason: {{ item.Rejection_Reason }}</b>
          </span>
        </template>
      </template>
      <template v-slot:[`item.Additional_Approved`]="{ item }">
        <template v-if="!item.Need_Additional_Approval">
          <span class="grey--text">—</span>
        </template>
        <template v-else-if="(item.Additional_Rejection_Reason != null && item.Additional_Rejection_Reason !== '') || item.Additional_Approved === 0 || item.Additional_Approved === false">
          <span class="error--text darken-2">
            Rejected by {{ item.Additional_Confirmer_Full_Name }}
            <br v-if="item.Additional_Rejection_Reason"><b v-if="item.Additional_Rejection_Reason">Reason: {{ item.Additional_Rejection_Reason }}</b>
          </span>
        </template>
        <template v-else-if="!item.Approved && item.Rejection_Reason">
          <span v-if="item.Additional_Approved" class="success--text darken-2">Approved by {{ item.Additional_Confirmer_Full_Name }}</span>
          <span v-else class="grey--text">{{ item.Additional_Confirmer_Full_Name }}</span>
        </template>
        <template v-else-if="!item.Approved">
          <span v-if="item.Additional_Approved" class="success--text darken-2">Approved by {{ item.Additional_Confirmer_Full_Name }}</span>
          <span v-else class="orange--text text--darken-2">Pending</span>
        </template>
        <template v-else>
          <span v-if="item.Additional_Approved" class="success--text darken-2">Approved by {{ item.Additional_Confirmer_Full_Name }}</span>
          <span v-else class="orange--text text--darken-2">Pending</span>
        </template>
      </template>
      <template v-slot:[`item.Reason_Type`]="{ item }">
        {{ reasonTypeLabel(item.Reason_Type) }}
      </template>
      <template v-slot:[`item.Equipment_Category`]="{ item }">
        {{ categoryLabel(item.Equipment_Category) }}
      </template>
      <template v-slot:[`item.Urgency`]="{ item }">
        <span :class="urgencyClass(item.Urgency)">{{ urgencyLabel(item.Urgency) }}</span>
      </template>
      <template v-slot:[`item.Justification`]="{ item }">
        <span class="text-pre-wrap">{{ (item.Justification || '').slice(0, 80) }}{{ (item.Justification || '').length > 80 ? '...' : '' }}</span>
      </template>
      <template v-slot:[`item.Confirmation_File_Name`]="{ item }">
        <span class="attachment-cell-inner">
          <a
            v-if="item.Confirmation_File_Name"
            @click="getFile(item)"
          >{{ item.Confirmation_File_Name }}</a>
          <span v-else>—</span>
        </span>
      </template>
      <template v-slot:[`item.Edit_Manage`]="{ item }">
        <td class="text-center text-no-wrap">
          <v-tooltip bottom color="info">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="info"
                @click="openRequest(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="red darken-2"
                @click="openDeleteDialog(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="showRejectDialog" max-width="400" persistent>
      <v-card>
        <v-card-title>Reject request</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-textarea v-model="rejectionReason" rows="2" label="Rejection reason"></v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="error" :disabled="!rejectionReason" @click="considerRequest(false)">Reject</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="showAcceptDialog"
      v-model="showAcceptDialog"
      :message="'Approve request?'"
      :confirmBtnName="'Approve'"
      @onApproveClick="considerRequest(true)"
      @onCancelClick="showAcceptDialog = false"
      @onCloseClick="showAcceptDialog = false"
    />
    <ConfirmOrDeniedDialog
      v-if="showDeleteDialog"
      v-model="showDeleteDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteRequest"
      @onCancelClick="showDeleteDialog = false"
      @onCloseClick="showDeleteDialog = false"
    />
    <EquipmentReplacementRequest
      v-if="requestForEquipmentReplacementDialog"
      v-model="requestForEquipmentReplacementDialog"
      :requestId="requestForEquipmentReplacementId"
      @getHistory="getHistory"
      @input="onRequestDialogInput"
    />
  </div>
</template>

<script>
import { getApiErrorMessage } from '@/utils/apiError'
export default {
  name: 'EquipmentReplacementRequestHistory',
  components: {
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    EquipmentReplacementRequest: () => import('@/components/employee/employee_requests/EquipmentReplacementRequest.vue')
  },
  props: {
    value: { required: true, default: false },
    employeeId: { required: false, default: null },
    fromRequestModule: { required: false, default: false }
  },
  data () {
    return {
      history: [],
      consideringRequest: null,
      showRejectDialog: false,
      showAcceptDialog: false,
      showDeleteDialog: false,
      requestForEquipmentReplacementDialog: false,
      requestForEquipmentReplacementId: null,
      rejectionReason: null,
      downloadLink: document.createElement('a'),
      reasonTypeLabels: {
        breakdown: 'Breakdown',
        issues: 'Issues',
        technical_limitations: 'Technical limitations',
        upgrade_needed: 'Upgrade needed',
        physical_breakdown: 'Breakdown',
        incorrect_operation: 'Issues',
        modernization: 'Upgrade needed'
      }
    }
  },
  mounted () {
    this.getHistory()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    headers () {
      return [
        { text: 'Created', value: 'Date_Of_Create', sortable: true, divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Updated', value: 'Date_Of_Update', sortable: true, divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Request type', value: 'Reason_Type', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Category', value: 'Equipment_Category', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Urgency', value: 'Urgency', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Description', value: 'Justification', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Confirmer', value: 'Confirmer_Full_Name', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap', show: !this.fromRequestModule },
        { text: 'Attachment', value: 'Confirmation_File_Name', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap attachment-cell' },
        { text: 'Status', value: 'Is_Pending', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Approved', value: 'Approved', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Additional approval', value: 'Additional_Approved', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap' },
        { text: 'Manage', value: 'Edit_Manage', divider: true, class: 'px-2 text-no-wrap', cellClass: 'px-2 text-pre-wrap', show: !this.fromRequestModule }
      ].filter(h => h.show !== false)
    }
  },
  methods: {
    reasonTypeLabel (value) {
      return this.reasonTypeLabels[value] || value
    },
    categoryLabel (value) {
      const labels = { laptop: 'Laptop', desktop: 'Desktop', monitor: 'Monitor', other: 'Other' }
      return labels[value] || value || '—'
    },
    urgencyLabel (value) {
      const labels = { standard: 'Standard', high: 'High', critical: 'Critical' }
      return labels[value] || value || 'Standard'
    },
    urgencyClass (value) {
      if (value === 'critical') return 'error--text'
      if (value === 'high') return 'orange--text text--darken-2'
      return ''
    },
    canConsider (item) {
      const uid = Number(this.user.employee_id)
      return Number(item.Confirmer_ID) === uid ||
        (!!item.Need_Additional_Approval && Number(item.Additional_Confirmer_ID) === uid)
    },
    isAdditionalApprover (item) {
      return !!item.Need_Additional_Approval && Number(item.Additional_Confirmer_ID) === Number(this.user.employee_id)
    },
    getHistory () {
      const id = this.employeeId || this.user.employee_id
      this.axios.get(`/api/requests/equipment_replacement/${id}`, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(res => {
        this.history = res.data
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    getFile (item) {
      this.axios.get(`/api/requests/equipment_replacement_file/${item.Request_ID}/Confirmation_File`, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(res => {
        const fileData = res.data[0]
        if (fileData && fileData.File && fileData.File.data) {
          this.openFile(item.Confirmation_File_Name, fileData.File.data, item.Confirmation_File_Type)
        }
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openFile (filename, data, type) {
      let binary = ''
      const bytes = new Uint8Array(data)
      for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i])
      this.downloadLink.href = `data:${type};base64,${window.btoa(binary)}`
      this.downloadLink.download = filename
      this.downloadLink.click()
      this.downloadLink.href = ''
    },
    openRejectDialog (item) {
      this.consideringRequest = item
      this.rejectionReason = null
      this.showRejectDialog = true
    },
    openAcceptDialog (item) {
      this.consideringRequest = item
      this.showAcceptDialog = true
    },
    considerRequest (approved) {
      const headers = { Authorization: 'Bearer ' + this.user.token }
      const isAdditional = this.isAdditionalApprover(this.consideringRequest)
      const payload = {
        Approved: approved ? 1 : 0,
        Confirmer_ID: this.user.employee_id,
        Rejection_Reason: approved ? null : this.rejectionReason,
        Is_Additional_Approval: isAdditional
      }
      this.axios.put(`/api/requests/consider_equipment_replacement/${this.consideringRequest.Request_ID}`, payload, { headers })
        .then(() => {
          this.$store.dispatch('setSuccess', { successMsg: approved ? 'Request approved' : 'Request rejected' })
          this.showAcceptDialog = false
          this.showRejectDialog = false
          this.rejectionReason = null

          const notifId = this.isAdditionalApprover(this.consideringRequest)
            ? this.consideringRequest.Additional_Notification_ID
            : this.consideringRequest.Notification_ID

          if (notifId) {
            this.axios.delete(`/api/notifications/${notifId}`, { headers })
              .catch(error => {
                this.$store.dispatch('setError', {
                  errorMsg: 'Failed to delete notification: ' + (error.message + ' - ' + ((error.response && error.response?.data) || ''))
                })
              })
          }

          this.sendEmailAboutEquipmentReplacementRequest(this.consideringRequest.Request_ID)
          this.getHistory()
        })
        .catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
    },
    sendEmailAboutEquipmentReplacementRequest (requestId) {
      this.axios.post('/api/emails/sendemailforequipmentreplacementrequest', { Request_ID: requestId }, {
        headers: { Authorization: 'Bearer ' + this.user.token }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        const errorMsg = getApiErrorMessage(error)
        this.$store.dispatch('setError', { errorMsg })
      })
    },
    openRequest (item) {
      this.requestForEquipmentReplacementId = item.Request_ID
      this.requestForEquipmentReplacementDialog = true
    },
    onRequestDialogInput (val) {
      if (!val) this.requestForEquipmentReplacementId = null
    },
    openDeleteDialog (item) {
      this.consideringRequest = item
      this.showDeleteDialog = true
    },
    deleteRequest () {
      const headers = { Authorization: 'Bearer ' + this.user.token }
      this.axios.delete(`/api/requests/equipment_replacement/${this.consideringRequest.Request_ID}`, { headers })
        .then(() => {
          if (this.consideringRequest.Notification_ID) {
            return this.axios.delete(`/api/notifications/${this.consideringRequest.Notification_ID}`, { headers })
          }
        })
        .then(() => {
          this.$store.dispatch('setSuccess', { successMsg: 'Request was deleted' })
          this.showDeleteDialog = false
          this.consideringRequest = null
          this.getHistory()
        })
        .catch(error => {
          const errorMsg = getApiErrorMessage(error)
          this.$store.dispatch('setError', { errorMsg })
        })
    }
  },
  watch: {
    value (val) {
      if (val) this.getHistory()
    }
  }
}
</script>
